import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getVersoes as getVersoesSdk,
  getVersao as getVersaoSdk,
  postVersao as postVersaoSdk,
  putVersao as putVersaoSdk,
  deleteVersao as deleteVersaoSdk,
  getVersaoConectores as getVersaoConectoresSdk,
  downloadVersao as downloadVersaoSdk,
} from '@sdk/Conectores/Versoes';

//Action Types
export const Types = {
  GET_VERSOES: 'GET_VERSOES',
  GET_VERSOES_SUCCESS: 'GET_VERSOES_SUCCESS',
  GET_VERSOES_ERROR: 'GET_VERSOES_ERROR',

  GET_VERSAO: 'GET_VERSAO',
  GET_VERSAO_SUCCESS: 'GET_VERSAO_SUCCESS',
  GET_VERSAO_ERROR: 'GET_VERSAO_ERROR',

  PUT_VERSAO: 'PUT_VERSAO',
  PUT_VERSAO_SUCCESS: 'PUT_VERSAO_SUCCESS',
  PUT_VERSAO_ERROR: 'PUT_VERSAO_ERROR',

  POST_VERSAO: 'POST_VERSAO',
  POST_VERSAO_SUCCESS: 'POST_VERSAO_SUCCESS',
  POST_VERSAO_ERROR: 'POST_VERSAO_ERROR',

  DELETE_VERSAO: 'DELETE_VERSAO',
  DELETE_VERSAO_SUCCESS: 'DELETE_VERSAO_SUCCESS',
  DELETE_VERSAO_ERROR: 'DELETE_VERSAO_ERROR',

  GET_VERSAO_CONECTORES: 'GET_VERSAO_CONECTORES',
  GET_VERSAO_CONECTORES_SUCCESS: 'GET_VERSAO_CONECTORES_SUCCESS',
  GET_VERSAO_CONECTORES_ERROR: 'GET_VERSAO_CONECTORES_ERROR',

  SET_VERSAO_SELECIONADA_TELA: 'SET_VERSAO_SELECIONADA_TELA',

  DOWNLOAD_VERSAO: 'DOWNLOAD_VERSAO',
  DOWNLOAD_VERSAO_SUCCESS: 'DOWNLOAD_VERSAO_SUCCESS',
  DOWNLOAD_VERSAO_ERROR: 'DOWNLOAD_VERSAO_ERROR',

  RESET_VERSOES: 'RESET_VERSOES',
};

//Action Creators
export const getVersoes = (page) => ({ type: Types.GET_VERSOES, page });
export const getVersoesSuccess = (data) => ({ type: Types.GET_VERSOES_SUCCESS, data });
export const getVersoesError = (error) => ({ type: Types.GET_VERSOES_ERROR, error });

export const getVersao = (nrBuild) => ({ type: Types.GET_VERSAO, nrBuild });
export const getVersaoSuccess = (versao) => ({ type: Types.GET_VERSAO_SUCCESS, versao });
export const getVersaoError = (error) => ({ type: Types.GET_VERSAO_ERROR, error });

export const postVersao = (data) => ({ type: Types.POST_VERSAO, data });
export const postVersaoSuccess = () => ({ type: Types.POST_VERSAO_SUCCESS });
export const postVersaoError = (error) => ({ type: Types.POST_VERSAO_ERROR, error });

export const putVersao = (data) => ({ type: Types.PUT_VERSAO, data });
export const putVersaoSuccess = () => ({ type: Types.PUT_VERSAO_SUCCESS });
export const putVersaoError = (error) => ({ type: Types.PUT_VERSAO_ERROR, error });

export const deleteVersao = (nrBuild) => ({ type: Types.DELETE_VERSAO, nrBuild });
export const deleteVersaoSuccess = (nrBuild) => ({ type: Types.DELETE_VERSAO_SUCCESS, nrBuild });
export const deleteVersaoError = (error) => ({ type: Types.DELETE_VERSAO_ERROR, error });

export const getVersaoConectores = (nrBuild) => ({ type: Types.GET_VERSAO_CONECTORES, nrBuild });
export const getVersaoConectoresSuccess = (versaoConectores) => ({ type: Types.GET_VERSAO_CONECTORES_SUCCESS, versaoConectores });
export const getVersaoConectoresError = (error) => ({ type: Types.GET_VERSAO_CONECTORES_ERROR, error });

export const downloadVersao = (nrBuild, jobConector, versaoDownload) => ({
  type: Types.DOWNLOAD_VERSAO,
  nrBuild,
  jobConector,
  versaoDownload,
});
export const downloadVersaoSuccess = () => ({ type: Types.DOWNLOAD_VERSAO_SUCCESS });
export const downloadVersaoError = (error) => ({ type: Types.DOWNLOAD_VERSAO_ERROR, error });

export const setVersaoSelecionadaTela = (nrBuildSelecionado) => ({ type: Types.SET_VERSAO_SELECIONADA_TELA, nrBuildSelecionado });

export const reset = () => ({ type: Types.RESET_VERSOES });

//saga

function* fetchGetVersoes(action) {
  try {
    const { page } = action;
    const versoes = yield call(getVersoesSdk, page);
    yield put(getVersoesSuccess(versoes));
  } catch (err) {
    Notification.error(err.message);
    yield put(getVersoesError(err));
  }
}

function* fetchGetVersao(action) {
  try {
    const versao = yield call(getVersaoSdk, action.nrBuild);
    yield put(getVersaoSuccess(versao));
  } catch (err) {
    Notification.error(err.message);
    yield put(getVersaoError(err));
  }
}

function* fetchDownloadVersao(action) {
  try {
    const { nrBuild, jobConector } = action;
    yield call(downloadVersaoSdk, nrBuild, jobConector);
    yield put(downloadVersaoSuccess());
    Notification.success('Download concluído');
  } catch (err) {
    Notification.error(err.message);
    yield put(downloadVersaoError(err));
  }
}

function* fetchPutVersao(action) {
  try {
    yield call(putVersaoSdk, action.data);
    yield put(putVersaoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putVersaoError(err));
  }
}

function* fetchPostVersao(action) {
  try {
    yield call(postVersaoSdk, action.data);
    yield put(postVersaoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postVersaoError(err));
  }
}

function* fetchDeleteVersao(action) {
  try {
    const { nrBuild } = action;
    yield call(deleteVersaoSdk, nrBuild);
    yield put(deleteVersaoSuccess(nrBuild));
  } catch (err) {
    Notification.error(err.message);
    yield put(deleteVersaoError(err));
  }
}

function* fetchGetVersaoConectores(action) {
  try {
    const { nrBuild } = action;
    const versaoConectores = yield call(getVersaoConectoresSdk, nrBuild);
    yield put(getVersaoConectoresSuccess(versaoConectores));
  } catch (err) {
    Notification.error(err.message);
    yield put(getVersaoConectoresError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_VERSOES, fetchGetVersoes),
  takeLatest(Types.GET_VERSAO, fetchGetVersao),
  takeLatest(Types.PUT_VERSAO, fetchPutVersao),
  takeLatest(Types.POST_VERSAO, fetchPostVersao),
  takeLatest(Types.DELETE_VERSAO, fetchDeleteVersao),
  takeLatest(Types.GET_VERSAO_CONECTORES, fetchGetVersaoConectores),
  takeLatest(Types.DOWNLOAD_VERSAO, fetchDownloadVersao),
];

// Reducer
const initialState = Map({
  versoes: List(),
  versaoConectores: List(),
  versao: {},
  nrBuildSelecionado: -1,
  versaoDownload: '',

  loadingVersoes: false,
  successVersoes: false,
  errorVersoes: false,

  loadingVersao: false,
  successVersao: false,
  errorVersao: false,

  puttingVersao: false,
  successPutVersao: false,
  errorPutVersao: false,

  postingVersao: false,
  successPostVersao: false,
  errorPostVersao: false,

  deletingVersao: false,
  successDeleteVersao: false,
  errorDeleteVersao: false,

  loadingVersaoConectores: false,
  successVersaoConectores: false,
  errorVersaoConectores: false,

  dowloadingVersao: false,
  successDowloadVersao: false,
  errorDowloadVersao: false,
});

const handleGetVersoes = (state, action) => {
  return state.set('loadingVersoes', true).set('successVersoes', false).set('errorVersoes', false);
};

const handleGetVersoesSuccess = (state, action) => {
  const { versoes } = action.data;
  return state.set('versoes', List(versoes)).set('loadingVersoes', false).set('successVersoes', true).set('errorVersoes', false);
};

const handleGetVersoesError = (state, action) => {
  return state.set('loadingVersoes', false).set('successVersoes', false).set('errorVersoes', action.error);
};

const handleGetVersaoConectores = (state, action) => {
  return state.set('loadingVersaoConectores', true).set('successVersaoConectores', false).set('errorVersaoConectores', false);
};

const handleGetVersaoConectoresSuccess = (state, action) => {
  const { versaoConectores } = action;

  return state
    .set('versaoConectores', List(versaoConectores))
    .set('loadingVersaoConectores', false)
    .set('successVersaoConectores', true)
    .set('errorVersaoConectores', false);
};

const handleGetVersaoConectoresError = (state, action) => {
  return state.set('loadingVersaoConectores', false).set('successVersaoConectores', false).set('errorVersaoConectores', action.error);
};

const handleGetVersao = (state, action) => {
  return state.set('loadingVersao', true).set('successVersao', false).set('errorVersao', false);
};

const handleGetVersaoSuccess = (state, action) => {
  const { versao } = action;

  return state.set('versao', versao[0]).set('loadingVersao', false).set('successVersao', true).set('errorVersao', false);
};

const handleGetVersaoError = (state, action) => {
  return state.set('loadingVersao', false).set('successVersao', false).set('errorVersao', action.error);
};

const handlePutVersao = (state, action) => {
  return state.set('puttingVersao', true).set('successPutVersao', false).set('errorPutVersao', false);
};

const handlePutVersaoSuccess = (state, action) => {
  return state.set('puttingVersao', false).set('successPutVersao', true).set('errorPutVersao', false);
};

const handlePutVersaoError = (state, action) => {
  return state.set('puttingVersao', false).set('successPutVersao', false).set('errorPutVersao', action.error);
};

const handleDeleteVersao = (state, action) => {
  return state.set('deletingVersao', true).set('successDeleteVersao', false).set('errorDeleteVersao', false);
};

const handleDeleteVersaoSuccess = (state, action) => {
  const { nrBuild } = action;
  const versoes = state.get('versoes').filter((value, index, arr) => value.nrBuild !== nrBuild);
  return state.set('deletingVersao', false).set('successDeleteVersao', true).set('errorDeleteVersao', false).set('versoes', versoes);
};

const handleDeleteVersaoError = (state, action) => {
  return state.set('deletingVersao', false).set('successDeleteVersao', false).set('errorDeleteVersao', action.error);
};

const handlePostVersao = (state, action) => {
  return state.set('postingVersao', true).set('successPostVersao', false).set('errorPostVersao', false);
};

const handlePostVersaoSuccess = (state, action) => {
  return state.set('posttingVersao', false).set('successPostVersao', true).set('errorPostVersao', false);
};
const handlePostVersaoError = (state, action) => {
  return state.set('posttingVersao', false).set('successPostVersao', false).set('errorPostVersao', action.error);
};

const handleDownloadVersao = (state, action) => {
  const { versaoDownload } = action;
  return state
    .set('versaoDownload', versaoDownload)
    .set('downloadingVersao', true)
    .set('successDownloadVersao', false)
    .set('errorDownloadVersao', false);
};

const handleDownloadVersaoSuccess = (state, action) => {
  return state.set('downloadingVersao', false).set('successDownloadVersao', true).set('errorDownloadVersao', false);
};

const handleDownloadVersaoError = (state, action) => {
  return state.set('downloadingVersao', false).set('successDownloadVersao', false).set('errorDownloadVersao', action.error);
};

const handleReset = (state, action) => {
  return state.set('successPutVersao', false).set('successPostVersao', false);
};

const handleSetVersaoSelecionadaTela = (state, action) => {
  const { nrBuildSelecionado } = action;
  return state.set('nrBuildSelecionado', nrBuildSelecionado);
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_VERSOES:
      return handleGetVersoes(state, action);
    case Types.GET_VERSOES_SUCCESS:
      return handleGetVersoesSuccess(state, action);
    case Types.GET_VERSOES_ERROR:
      return handleGetVersoesError(state, action);

    case Types.GET_VERSAO:
      return handleGetVersao(state, action);
    case Types.GET_VERSAO_SUCCESS:
      return handleGetVersaoSuccess(state, action);
    case Types.GET_VERSAO_ERROR:
      return handleGetVersaoError(state, action);

    case Types.POST_VERSAO:
      return handlePostVersao(state, action);
    case Types.POST_VERSAO_SUCCESS:
      return handlePostVersaoSuccess(state, action);
    case Types.POST_VERSAO_ERROR:
      return handlePostVersaoError(state, action);

    case Types.PUT_VERSAO:
      return handlePutVersao(state, action);
    case Types.PUT_VERSAO_SUCCESS:
      return handlePutVersaoSuccess(state, action);
    case Types.PUT_VERSAO_ERROR:
      return handlePutVersaoError(state, action);

    case Types.DELETE_VERSAO:
      return handleDeleteVersao(state, action);
    case Types.DELETE_VERSAO_SUCCESS:
      return handleDeleteVersaoSuccess(state, action);
    case Types.DELETE_VERSAO_ERROR:
      return handleDeleteVersaoError(state, action);

    case Types.GET_VERSAO_CONECTORES:
      return handleGetVersaoConectores(state, action);
    case Types.GET_VERSAO_CONECTORES_SUCCESS:
      return handleGetVersaoConectoresSuccess(state, action);
    case Types.GET_VERSAO_CONECTORES_ERROR:
      return handleGetVersaoConectoresError(state, action);

    case Types.SET_VERSAO_SELECIONADA_TELA:
      return handleSetVersaoSelecionadaTela(state, action);

    case Types.DOWNLOAD_VERSAO:
      return handleDownloadVersao(state, action);
    case Types.DOWNLOAD_VERSAO_SUCCESS:
      return handleDownloadVersaoSuccess(state, action);
    case Types.DOWNLOAD_VERSAO_ERROR:
      return handleDownloadVersaoError(state, action);

    case Types.RESET_VERSOES:
      return handleReset(state, action);

    default:
      return state;
  }
}
